<template>
    <header
        class="fixed z-10 flex top-0 right-0 left-0 lg:pl-[224px] h-12 md:h-16 px-4 justify-end items-center bg-main-bg-500 dark:bg-main-bg-dark-500 shadow-app-vs-light dark:shadow-app-vs-dark transition-spacing duration-300 ease-in-out"
        :class="[menuState === 'opened' ? 'pl-[224px]' : 'ml-0']"
    >
        <color-mode-switcher
            class="p-4 -m-4 lg:p-2 lg:-m-2 text-app-font-grey-500 dark:text-app-font-grey-dark-500 hover:text-app-font-grey-600 dark:hover:text-app-font-grey-dark-600 focus:text-app-font-grey-600 dark:focus:text-app-font-grey-dark-600 active:text-app-font-grey-400 transition-colors duration-300 ease-in-out"
        />
    </header>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import ColorModeSwitcher from '@/common/components/ui/ColorModeSwitcher.vue'

export default defineComponent({
    name: 'TheHeader',
    components: {
        ColorModeSwitcher,
    },
    setup() {
        const store = useStore()

        const menuState = computed(() => store.getters['ui/menuState'])

        return {
            menuState,
        }
    },
})
</script>
